import { useDispatch, useSelector } from 'react-redux'
import { addFilter } from '../redux/executionTasksSlice';



export default function useHeaderFleetExecutionsTasks(){
    const filters = useSelector((state: any) => state.executionTask.filters)
    const dispatch = useDispatch()
    const handdleFilters = (key: string, value: string) => {
        const order = 'order'
        dispatch(addFilter({...filters, [order]:{[key]:value}}))
    }
    return {handdleFilters, filters}
}